import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { GuestAppHeader } from "./GuestAppHeader"

interface PublicLayoutProps {
  children?: React.ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps) {
  const [backgroundImage, setBackgroundImage] = useState(
    "https://cdn.rituality.com/assets/bg-connect.jpg",
  )

  useEffect(() => {
    const backgrounds = [
      "https://cdn.rituality.com/assets/bg-connect.jpg",
      "https://cdn.rituality.com/assets/bg-learn.jpg",
    ]
    setBackgroundImage(backgrounds[Math.floor(Math.random() * backgrounds.length)])
  }, [])

  return (
    <div className="relative min-h-screen">
      <div
        className="absolute top-0 left-0 right-0 h-122.75 -z-10 w-full bg-cover bg-no-repeat bg-center md:bg-[position:185%]"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(180deg, rgba(2, 2, 2, 0.27) 0%, #020202 100%)",
          }}
        />
      </div>

      <GuestAppHeader />

      <div className="pt-[70px] md:pb-0 pb-[85px]">{children || <Outlet />}</div>
    </div>
  )
}
